import { Button, Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { COLOR_BLANC, COLOR_BLEU_EM, COLOR_GRIS_2 } from '../../colors';
import drawPicture from '../../../../scripts/modules/vehicleCondition/draw-picture';
import Loader from '../../svg/Loader.svg';
import VehicleConditionManager from '../../../../scripts/modules/vehicleCondition/vehicle-condition-manager';

const NO_PICTURE_HEIGHT_PX = 150;
const PICTURE_MARGIN_PX = 15;
const WAY_WIDTH_PX = 40;
const WAY_OFFSET_PX = -1 * (PICTURE_MARGIN_PX + (WAY_WIDTH_PX / 2));

const FullScreenPicture = styled.div`
    .no-picture {
        height: ${NO_PICTURE_HEIGHT_PX}px;
        padding-top: 35px;
    }

    .picture-container {
        position: relative;

        div.close {
            height: 42px;
            opacity: initial;
            position: absolute;
            right: -18px;
            top: -53px;
            width: 42px;

            button.close {
                color: ${COLOR_BLANC};
                float: none;
                font-size: 3.6rem;
                height: 100%;
                opacity: initial;
                width: 100%;

                &:hover {
                    background-color: ${COLOR_BLANC};
                    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
                    border: 1px solid ${COLOR_GRIS_2};
                    color: ${COLOR_BLEU_EM};
                }
            }
        }

        .page {
            position: relative;
            top: -16px;
        }

        .way {
            color: ${COLOR_BLEU_EM};
            font-size: 3rem;
            font-weight: bold;
            height: ${WAY_WIDTH_PX}px;
            padding: 0;
            position: absolute;
            width: ${WAY_WIDTH_PX}px;

            &:after {
                font-family: 'EM-icomoon';
            }

            &.left {
                left: ${WAY_OFFSET_PX}px;

                &:after {
                    content: '\f104';
                }
            }

            &.right {
                right: ${WAY_OFFSET_PX}px;

                &:after {
                    content: '\f105';
                }
            }
        }
    }
`;

const ModalFullScreenPicture = (
    {
        def,
        nbPictures,
        onClickNext,
        onClickPrevious,
        onHide,
        picture,
        pictureNumber,
    },
) => {
    const pictureError = picture?.error === true;
    const picturePresent = (picture?.downloaded === true) && (!pictureError);

    let content = null;
    if (picture) {
        const pictureAvailableHeight = (window.innerHeight * 0.8) - (2 * PICTURE_MARGIN_PX);
        const pictureAvailableWidth = (window.innerWidth * 0.8) - (2 * PICTURE_MARGIN_PX);

        const handlePictureContainerRef = element => {
            if (element) {
                element
                    .querySelectorAll('canvas')
                    .forEach(canvas => canvas.remove());

                if (picturePresent) {
                    const canvas = document.createElement('canvas');

                    drawPicture.drawPicture(
                        def,
                        picture,
                        canvas,
                        pictureAvailableWidth,
                        pictureAvailableHeight,
                    );

                    element.prepend(canvas);
                }
            }
        };

        const dimensionsToDisplayPicture = VehicleConditionManager.getScaleAndDimensionsToDisplayPicture(
            picture,
            pictureAvailableWidth,
            pictureAvailableHeight,
        );

        const wayStyle = {
            top: picturePresent
                ? (dimensionsToDisplayPicture.imgScaleHeight / 2) - (WAY_WIDTH_PX / 2)
                : (NO_PICTURE_HEIGHT_PX / 2) - (WAY_WIDTH_PX / 2),
        };

        content = (
            <FullScreenPicture>
                <div
                    className="picture-container"
                    ref={handlePictureContainerRef}
                    style={{
                        width: picturePresent ? dimensionsToDisplayPicture.imgScaleWidth : 500,
                    }}
                >
                    <div className="close">
                        <Button className="close" onClick={onHide}>
                            <span aria-hidden="true">×</span>
                        </Button>
                    </div>

                    {
                        (nbPictures > 1) && (
                            <>
                                <Button className="left way whiteCard" onClick={onClickPrevious} style={wayStyle} />
                                <Button className="right way whiteCard" onClick={onClickNext} style={wayStyle} />
                            </>
                        )
                    }

                    {
                        (picture?.downloading === true) && (
                            <div className="no-picture">
                                <Loader />
                            </div>
                        )
                    }

                    {
                        pictureError && (
                            <div className="no-picture">
                                Échec du chargement de la photo.
                            </div>
                        )
                    }

                    <div className="page">
                        <span className="bold px-16 py-11 whiteCard">
                            {`${pictureNumber} sur ${nbPictures}`}
                        </span>
                    </div>

                    <div className="bold">
                        {def ? `${def.label} ${def.description}` : null}
                    </div>
                </div>
            </FullScreenPicture>
        );
    }

    return (
        <Modal id="modal-default-pictures-full-screen" show={!!picture}>
            <Modal.Body className="text-center">
                {content}
            </Modal.Body>
        </Modal>
    );
};

ModalFullScreenPicture.defaultProps = {
    def: null,
    picture: null,
};

ModalFullScreenPicture.propTypes = {
    def: PropTypes.shape({
        description: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
    }),
    nbPictures: PropTypes.number.isRequired,
    onClickNext: PropTypes.func.isRequired,
    onClickPrevious: PropTypes.func.isRequired,
    onHide: PropTypes.func.isRequired,
    picture: PropTypes.shape({
        downloaded: PropTypes.bool,
        downloading: PropTypes.bool,
        error: PropTypes.bool,
    }),
    pictureNumber: PropTypes.number.isRequired,
};

export default ModalFullScreenPicture;
